import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormControl, AbstractControl, ValidationErrors, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ApplicationDataService } from '../../../core/services/application-data.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';

interface Session {
  sr?: number;
  phoneNumber: string;
  messageCount: number;
}

interface ChatMessage {
  message: string;
  dateTime: string;
  direction: 'INBOUND' | 'OUTBOUND';
  messageType?: string;
  sessionStatus?: string;
  messageStep?: string;
}

@Component({
  selector: 'app-whatsapp-conversations',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatInputModule, MatDatepickerModule, MatNativeDateModule],
  templateUrl: './conversations.component.html',
  styleUrls: ['./conversations.component.css']
})
export class WhatsAppConversationsComponent implements OnInit, OnDestroy {

  sessions: Session[] = [];
  totalElements = 0;
  totalPages = 0;
  currentPage = 0;
  pageSize = 20;
  form: FormGroup;
  
  searchControl = new FormControl('');
  fromDate = '';
  toDate = '';
  dateError = '';
  isLoading = false;

  showModal = false;
  isModalLoading = false;
  selectedPhone = '';
  messages: ChatMessage[] = [];

  private destroy$ = new Subject<void>();

  constructor(private appDataService: ApplicationDataService){}
    // private fb: FormBuilder,

  // ) {
    // this.form = this.fb.group({
    //       dateFrom: [null],
    //       dateTo: [null],
    //     }, { validators: this.dateRangeValidator });
      // }

  ngOnInit(): void {
  this.loadSessions();

    // ✅ Reset To Date if invalid
    // this.form.get('dateFrom')?.valueChanges.subscribe((from) => {
    //   if (from) {
    //     this.fromDate = from;
    //   }

    //   const to = this.form.get('dateTo')?.value;

    //   if (to && from && new Date(to) < new Date(from)) {
    //     this.form.get('dateTo')?.setValue(null);
    //     this.toDate = '';
    //   }
    // });

    // // ✅ Sync To Date
    // this.form.get('dateTo')?.valueChanges.subscribe((to) => {
    //   if (to) {
    //     this.toDate = to;
    //   }
    // });
  }

  onSearchKeyPress(event: KeyboardEvent): boolean {
    return /\d/.test(event.key);
  }

  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    if (input.value !== digits) {
      this.searchControl.setValue(digits, { emitEvent: false });
      input.value = digits;
    }
  }

  // validateDates(): boolean {
  //   if (this.fromDate && this.toDate) {
  //     const from = new Date(this.fromDate);
  //     const to = new Date(this.toDate);

  //     if (from > to) {
  //       this.dateError = 'Date From cannot be greater than Date To.';
  //       return false;
  //     }
  //   }

  //   this.dateError = '';
  //   return true;
  // }

  // dateRangeValidator(control: AbstractControl): ValidationErrors | null {
  //     const dateFrom = control.get('dateFrom')?.value;
  //     const dateTo = control.get('dateTo')?.value;
  
  //     if (dateFrom && dateTo && dateFrom > dateTo) {
  //       return { dateRangeInvalid: true };
  //     }
  //     return null;
  //   }
    

  applyFilters(): void {
    // if (!this.validateDates()) return;
    this.currentPage = 0;
    this.loadSessions();
  }

  loadSessions(): void {
    this.isLoading = true;
    const body: any = {};
    if (this.searchControl.value) body.mobileNumber = this.searchControl.value;
    // if (this.fromDate) body.dateFrom = this.fromDate + 'T00:00:00';
    // if (this.toDate)   body.dateTo   = this.toDate   + 'T23:59:59';

    if (this.fromDate) {
      const from = new Date(this.fromDate);
      body.dateFrom = from.toISOString().split('T')[0] + 'T00:00:00';
    }

    if (this.toDate) {
      const to = new Date(this.toDate);
      body.dateTo = to.toISOString().split('T')[0] + 'T23:59:59';
    }

    this.appDataService.getWhatsAppSessions(body, this.currentPage, this.pageSize).subscribe({
      next: (res) => {
        const list = Array.isArray(res?.content) ? res.content : [];
        this.sessions = list.map((s: any, i: number) => ({
          ...s,
          sr: this.currentPage * this.pageSize + i + 1
        }));
        this.totalElements = res?.totalElements ?? 0;
        this.totalPages = res?.totalPages ?? 0;
        this.isLoading = false;
      },
      error: () => {
        this.sessions = [];
        this.isLoading = false;
      }
    });
  }

  openConversation(phone: string): void {
    if (!phone) return;
    this.selectedPhone = phone;
    this.showModal = true;
    this.isModalLoading = true;

    this.appDataService.getWhatsAppConversation(phone).subscribe({
      next: (res) => {
        this.messages = Array.isArray(res) ? res : res?.data || [];
        this.isModalLoading = false;
      },
      error: () => {
        this.messages = [];
        this.isModalLoading = false;
      }
    });
  }

  closeModal(): void {
    this.showModal = false;
    this.messages = [];
    this.selectedPhone = '';
  }

  onClear(): void {
    this.searchControl.setValue('');
    this.fromDate = '';
    this.toDate = '';
    this.dateError = '';
    this.currentPage = 0;
    this.loadSessions();
  }

  goToPrev(): void {
    if (this.currentPage > 0) { this.currentPage--; this.loadSessions(); }
  }

  goToNext(): void {
    if (this.currentPage < this.totalPages - 1) { this.currentPage++; this.loadSessions(); }
  }

  get displayPage(): number { return this.currentPage + 1; }
  get pageEnd(): number { return Math.min((this.currentPage + 1) * this.pageSize, this.totalElements); }

  trackByIndex(index: number): number { return index; }

  isSessionMarker(msg: ChatMessage): boolean {
    return !!msg.sessionStatus && msg.sessionStatus !== 'ACTIVE';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}